import React, { useMemo } from 'react';
import { Route, Routes, useLocation, useParams } from 'react-router-dom';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useIntl } from 'react-intl';

import NavigationBar from 'carbon-react/lib/components/navigation-bar';

import {
  getConsolidationDetailRoutePath,
  getConsolidationsRoutePath,
  ROUTES,
  useMobileOrTableWindowResize
} from '@futrli/shared-services';
import { PrimaryNavView } from '@futrli/views/views/nav/PrimaryNavView/PrimaryNavView';
import { useApiView } from '@futrli/views/hooks/useApiView';

import { PrimaryNavDesktop } from '../primary-nav-desktop/primary-nav-desktop';
import { PrimaryNavMobile } from '../primary-nav-mobile/primary-nav-mobile';
import { shouldHideNav } from '../../../../../skeleton/src/utils/routes-utils';

const workspaces = [ROUTES.WORKSPACES_ROUTE];
const workspace = [...workspaces, ROUTES.WORKSPACE_BY_ID_ROUTE];
const workspaceSettings = [...workspace, ROUTES.WORKSPACE_BY_ID_SETTINGS_ROUTE];
const organisations = [...workspace, ROUTES.ORGANISATIONS_ROUTE];
const organisationsTab = [...organisations, ROUTES.ORGANISATIONS_ROUTE];
const consolidationsTab = [...organisations, ROUTES.CONSOLIDATIONS_ROUTE];
const organisation = [...organisations, ROUTES.ORGANISATION_BY_ID_ROUTE];
const consolidations = [getConsolidationsRoutePath()];
const consolidation = [getConsolidationDetailRoutePath()];
const organisationReporting = [...organisation, ROUTES.REPORTING];

// Warning - the order of routes is important. You want the most specific ones first!
const allowedNavBarRoutes = [
  organisationReporting,
  organisationsTab,
  consolidationsTab,
  organisation,
  organisations,
  consolidation,
  consolidations,
  workspaceSettings,
  workspace,
  workspaces
];

const PrimaryNavContainerInner = () => {
  const flags = useFlags();
  const { workspaceId = '' } = useParams();
  const isMobile = useMobileOrTableWindowResize();
  const view = useApiView(useMemo(() => new PrimaryNavView(flags, workspaceId), [flags, workspaceId]));

  return isMobile ? <PrimaryNavMobile view={view} /> : <PrimaryNavDesktop view={view} />;
};

export const PrimaryNavContainer = () => {
  const location = useLocation();
  const intl = useIntl();

  if (shouldHideNav(location)) {
    return null;
  }

  return (
    <NavigationBar
      variant="black"
      position="sticky"
      orientation="top"
      padding="0 20px"
      ariaLabel={intl.formatMessage({
        id: 'predict.main_navigation_bar.label',
        defaultMessage: 'Main navigation bar'
      })}
    >
      <Routes>
        {allowedNavBarRoutes.map(route => (
          <Route key={route.join('/')} path={`${route.join('')}/*`} element={<PrimaryNavContainerInner />} />
        ))}
      </Routes>
    </NavigationBar>
  );
};
